import moment from "moment";
import React, { useEffect, useState } from "react";
import { translate } from "react-i18next";
import { shippingSamplesSearch, healthFacilitiesExcluded, shippingSamplesSave } from "../../../libs/services";
import swal from 'sweetalert';
import RaisedButton from 'material-ui/RaisedButton';

const ShippingSamplesNew = ({t, waiting, history})=>{
    const [search, setSearch] = useState({
        type:'fecha',
        start_date:moment().format('YYYY-MM-DD'),
        end_date:moment().format('YYYY-MM-DD'),
        start_folio:'',
        end_folio:''
    });

    const [data, setData] = useState({
        hf_id: sessionStorage.getItem('health_facilities_id'),
        receiving_center_id:'',
        receiving_user:'',
        sample_ids:[]
    });

    const [list, setList] = useState([]);
    const [checkAll, setAll] = useState(false);
    const [health_facilities, setHf] = useState([]);

    const onSearch = async ()=>{
        let error = '';
        if(search.type === 'folio'){
            if(search.start_folio === '' || search.end_folio === ''){
                error = 'Campos incompletos';
            }

            if(search.start_folio === ''){
                document.getElementById('start_folio').classList.add('error');
            }else{
                document.getElementById('start_folio').classList.remove('error');
            }

            if(search.end_folio === ''){
                document.getElementById('end_folio').classList.add('error');
            }else{
                document.getElementById('end_folio').classList.remove('error');
            }

        }else{
            
            if(search.start_date === '' || search.end_date === ''){
                error = 'Campos incompletos';
            }

            if(search.start_date === ''){
                document.getElementById('start_date').classList.add('error');
            }else{
                document.getElementById('start_date').classList.remove('error');
            }

            if(search.end_date === ''){
                document.getElementById('end_date').classList.add('error');
            }else{
                document.getElementById('end_date').classList.remove('error');
            }
        }

        if(error === ''){
            let hf_id = sessionStorage.getItem('health_facilities_id');
            let response = await shippingSamplesSearch(search.start_date, search.end_date, search.start_folio, search.end_folio, hf_id, waiting);
            if(response){
                response.forEach((res)=>{
                    res.check = false;
                })
                setList(response);
            }
        }else{
            swal('Error', error, 'error');
        }
    }

    const handleChange = (e)=>{
        let name = e.target.name;
        let value = e.target.value;

        let item = search;
        item = {
            ...item,
            [name]: value
        };

        if(name === 'type'){
            if(value === 'fecha'){
                item.start_folio = '';
                item.end_folio = '';
            }else{
                item.start_date = '';
                item.end_date = '';
            }
        }

        setSearch(item);

    }

    const datachange = (e)=>{
        let name = e.target.name;
        let value = e.target.value;

        let item = data;
        item = {
            ...item,
            [name]: value
        };

        setData(item);
    }

    const selectAll = (e, i = null)=>{
        let check = false;

        check = e.target.checked;

        let items = list.map((l, index)=>{
            if(i === null){
                l.check = check;
            }else{
                if(i === index){
                    l.check = check;
                }
            }

            return l;
        })
        
        if(e.target.name === 'showAll'){
            setAll(check);
        }
        
        setList(items);
    }

    const getCenter = async ()=>{
        let hf_id = sessionStorage.getItem('health_facilities_id');
        let response = await healthFacilitiesExcluded(hf_id);
        if(response){
            setHf(response);
        }
    }

    const onSave = async ()=>{
        let error = '';

        if(data.receiving_center_id === '' || data.receiving_user === ''){
            error = 'Campos incompletos';
        }

        if(data.receiving_center_id === ''){
            document.getElementById('receiving_center_id').classList.add('error');
        }else{
            document.getElementById('receiving_center_id').classList.remove('error');
        }

        if(data.receiving_user === ''){
            document.getElementById('receiving_user').classList.add('error');
        }else{
            document.getElementById('receiving_user').classList.remove('error');
        }

        let obj = data;
        obj.sample_ids  = [];
        list.map((l)=>{
            if(l.check){
                obj.sample_ids.push(l.id);
            }
        })

        if(obj.sample_ids.length === 0){
            error = 'Debe seleccionar por lo menos un elemento de la tabla';
        }

        if(error === ''){        
            let response = await shippingSamplesSave(obj, waiting);
            if(response){
                onCancel();
            }
        }else{
            swal('Error', error, 'error');
        }
    }

    const onCancel = ()=>{
        history.push('/shipping_samples/list');
    }

    useEffect(()=>{
        getCenter();
    },[]);

    return(
        <div className="col-xs-12">
            <div className="route">
                <h5 className="title_page" >
                    {sessionStorage.getItem('health_facilities_name')} ->
                    {t('sidebar.nav.laboratory.MAIN')} -> 
                    {'Envio de Muestras -> Registro'}
                </h5>
            </div>
            <div className="col-xs-12 form-group">
                <div className="col-xs-12 col-sm-2">
                    <span className="span-min">Buscar por</span>
                    <select className="form-control input-sm" value={search.type} id="type" name="type" onChange={(e)=>handleChange(e)}>
                        <option value="folio">Folio</option>
                        <option value="fecha">Fecha</option>
                    </select>
                </div>
                {search.type === 'fecha' ?
                    <>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Fecha Desde</span>
                            <input type="date" className='form-control input-sm' id="start_date" name="start_date" value={search.start_date} onChange={(e)=>handleChange(e)} required/>
                        </div>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Fecha Hasta</span>
                            <input type="date" className='form-control input-sm' id="end_date" name="end_date" value={search.end_date} onChange={(e)=>handleChange(e)} required/>
                        </div>
                    </>
                : 
                    <>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Folio Desde</span>
                            <input type="date" className='form-control input-sm' id="start_folio" name="start_folio" value={search.start_folio} onChange={(e)=>handleChange(e)} required/>
                        </div>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Folio Hasta</span>
                            <input type="date" className='form-control input-sm' id="end_folio" name="end_folio" value={search.end_folio} onChange={(e)=>handleChange(e)} required/>
                        </div>
                    </>
                }

                <div className='col-xs-12 col-sm-2' style={{marginTop:20}}>
                    <button className='btn btn-info' onClick={()=>onSearch()}>Buscar</button>
                </div>
            </div>
            <div className="form-group col-xs-12">
                <div className="col-xs-12 col-sm-4">
                    <span className="span-min">Centro destino</span>
                    <select className="form-control input-sm" id="receiving_center_id" name="receiving_center_id" value={data.receiving_center_id} onChange={(e)=>datachange(e)}>
                        <option value="">Seleccione...</option>
                        {health_facilities.map((hf, i)=>
                            <option value={hf.id}>{hf.name}</option>
                        )}
                    </select>
                </div>
                <div className="col-xs-12 col-sm-4">
                    <span className="span-min">Usuario que recibe</span>
                    <input className="form-control input-sm" id="receiving_user" name="receiving_user" value={data.receiving_user} onChange={(e)=>datachange(e)} />
                </div>
            </div>

            <div className="form-group col-xs-12">
                <table className="table table-responsive table-hover">
                    <thead>
                        <tr>
                            <th>
                                <input type="checkbox" id="checkAll" name="checkAll" value={checkAll} checked={checkAll} onChange={(e)=>selectAll(e)} />
                            </th>
                            <th>No. Muestra</th>
                            <th>Fecha</th>
                            <th>Donador/Paciente</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((l, i)=>
                            <tr key={i}>
                                <td>
                                    <input type="checkbox" id="checkAll" name="checkAll" value={l.check || ""} checked={l.check} onChange={(e)=>selectAll(e, i)} />
                                </td>
                                <td>{l.number}</td>
                                <td>{moment(l.timestamp).format('DD/MM/YYYY')}</td>
                                <td>{l.person_name}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="form-group col-xs-12">
                {list.length > 0 &&
                    <div className="col-xs-12" style={{textAlign:"center"}}>
                        <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={onSave} />
                        <RaisedButton className="action-btn" label={t('content.generics.buttons.reset')} primary={true} onClick={onCancel} style={{marginLeft:5}}/>
                    </div>
                }
            </div>
        </div>
    )
}

export default translate('translations')(ShippingSamplesNew);